<template>
    <div id="areaChart">
        <ApexChart ref="areaChart" type="area" height="360" :options="chartOptions" :series="series"></ApexChart>
        <div class="legend-bar">
            <div class="item" v-for="(item, index) in series" :key="index">
                <el-checkbox @change="toggleSeries(item.name)" v-model="item.checkbox">{{ item.name }}</el-checkbox>
                <i v-if="item.name !== '全部'" @click="removeItem(item.id)" class="el-icon-close"></i>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
const chartOptionsConfig = {
    colors: ['#5914EE', '#15B366', '#FFBA44', '#FBA6AE', '#5BD0D3', '#FD9C02', '#175EA6', '#9C633B', '#F4767A', '#DD70C9'],
    chart: {
        type: 'area',
        toolbar: {
            show: false,
        },
        zoom: {
            enabled: false
        }
    },
    grid: {
        borderColor: '#DCE0E4',
    },
    dataLabels: {
        enabled: false
    },
    tooltip: {
        x: {
            formatter: function (value) {
                return dayjs(value).format('YYYY-MM-DD')
            }
        },
        y: {
            formatter: function (value) {
                return Number(value).toLocaleString();
            }
        }
    },
    xaxis: {
        type: 'datetime',
        categories: [],
        labels: {
            format: 'yyyy-MM-dd'
        }
    },
    legend: {
        show: false
    },
    fill: {
        type: "gradient",
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
        }
    },
};

export default {
    props: {
        // series: {
        //     type: Array,
        //     default: () => []
        // }
    },
    data() {
        return {
            chartOptions: { ...chartOptionsConfig },
            series: []
        }
    },
    methods: {
        refresh(categories, series) {
            const xaxisConfig = {
                xaxis: {
                    categories,
                }
            }
            const chartOptions = JSON.parse(JSON.stringify({ ...chartOptionsConfig, ...xaxisConfig }));
            this.chartOptions = chartOptions
            this.series = series;
        },
        toggleSeries(name) {
            this.$refs['areaChart'].toggleSeries(name);
        },
        removeItem(id) {
            this.$emit('removeItem', id);
        }
    }
}
</script>
<style lang="scss">
#areaChart {
    .apexcharts-text tspan {
        color: $-text-600;
        font-size: 12px;
    }

    .apexcharts-tooltip.apexcharts-theme-light {
        background: rgba(255, 255, 255, .98);
        border: 1px solid $--border-color-base;
        padding: 0 20px 20px 20px;

        .apexcharts-tooltip-title {
            background: transparent;
            border-bottom: none;
            text-align: center;
            padding-top: 20px;
            font-size: 18px !important;
            color: $-text-950;
            line-height: 18px;
            font-weight: bold;
        }

        .apexcharts-tooltip-text {
            font-size: 14px !important;
            flex: 1;
        }
    }

    .apexcharts-xaxistooltip,
    .apexcharts-yaxistooltip {
        border-color: $--border-color-base;
        background: $--input-background-color;
        border-radius: 6px;
    }

    .apexcharts-xaxis-tick {
        opacity: 0;
    }

    .apexcharts-tooltip-y-group {
        padding: 0px;
        display: flex;
        justify-content: space-between;
    }

    .apexcharts-xaxistooltip-bottom:before {
        border-bottom-color: $--border-color-base;
    }

    .apexcharts-xaxistooltip-bottom:after {
        border-bottom-color: $--input-background-color;
    }

    .apexcharts-legend {
        padding-top: 20px;
    }

    .legend-bar {
        text-align: center;

        .item {
            height: 36px;
            border-radius: 4px;
            border: 1px solid $--border-color-base;
            display: inline-block;
            padding: 0 14px;
            line-height: 36px;
            margin: 0 5px;

            .el-icon-close {
                font-weight: bold;
                margin-left: 10px;
                cursor: pointer;

                &:hover {
                    color: $-text-600;
                }
            }

            .el-checkbox__input {
                top: -1px;
            }

            &:nth-child(1) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #5914EE;
                border-color: #5914EE;
                opacity: 0.6;
            }

            &:nth-child(2) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #15B366;
                border-color: #15B366;
            }

            &:nth-child(3) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #FFBA44;
                border-color: #FFBA44;
            }

            &:nth-child(4) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #FBA6AE;
                border-color: #FBA6AE;
            }

            &:nth-child(5) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #5BD0D3;
                border-color: #5BD0D3;
            }

            &:nth-child(6) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #FD9C02;
                border-color: #FD9C02;
            }

            &:nth-child(7) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #175EA6;
                border-color: #175EA6;
            }

            &:nth-child(8) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #9C633B;
                border-color: #9C633B;
            }

            &:nth-child(9) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #F4767A;
                border-color: #F4767A;
            }

            &:nth-child(10) .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #DD70C9;
                border-color: #DD70C9;
            }
        }
    }
}
</style>